<div class="manage-bin-modal" rtlDiv>
    <div class="manage-bin-header">{{ 'SITE_MANAGMENT.CREATE_SITE' |  translate }}</div>
    <div class="manage-bit-body">
      <form [formGroup]="ElForm">
        <div class="bin-name-container">
          <div class="sub-title">{{ 'MANAGE_SITE.ACCOUNT' | translate }}</div>
          <select class="bin-name-input distrebution-Methods" formControlName="customerAccount" id="customer_accounts">
            @for (account of accountsList; track account) {
              <option [value]="account['account_id']" class="method-option">
                {{account['account_name']}}
              </option>
            }
          </select>
        </div>
  
        <div class="bin-name-container">
          <div class="sub-title-main">{{ 'TITLES.SITE_NAME' | translate }}</div>
          <div class="bin-name-input">
            <input id="site_name" formControlName="siteName" type="text" class="input-bin-name"  name="siteName" />
          </div>
        </div>
  
        <div class='bin-name-container' rtlDiv>
          <div class="sub-title-main">{{ 'SITE_MANAGMENT.INS_PROFILE' | translate }}</div>
          <mat-select class="bin-name-input distrebution-Methods" formControlName="profileIns" name="profiles" multiple>
            @for (profile of binsInstallationProfiles; track profile) {
              <mat-option class="profile-option" [value]="profile.bins_installation_profile_id" rtlDiv>
                {{ currentLang != 'iw' ? profile.bins_installation_profile_name : profile.bins_installation_profile_name_hebrew }}
              </mat-option>
            }
          </mat-select>
        </div>
  
        <mat-accordion>
          <mat-expansion-panel [expanded]="true" (opened)="workPlanOpenState = true" (closed)="workPlanOpenState = false" class="panel-accordion">
            <mat-expansion-panel-header class="panel-accordion-header">
              <mat-panel-title class="panel-accordion-title">
                {{ 'MANAGE_BIN.WORKPLAN' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div [ngClass]="{'hide-panel' : !workPlanOpenState}">
              <div class="bin-name-container">
                <div class="sub-title">{{ 'LIST_COLUMNS.DYNAMIC_WORKPLAN' | translate }}</div>
                <select class="bin-name-input distrebution-Methods" formControlName="DynamicWorkplan" id="dynamic_workplan">
                  @for (method of dynamicWorkplan; track method) {
                    <option [value]="method['work_plan_auto_update_type_id']" class="method-option">
                      {{currentLang != 'iw' ? method['work_plan_auto_update_type_name'] : method['work_plan_auto_update_type_name_hebrew']}}
                    </option>
                  }
                </select>
              </div>
  
              <div class="bin-name-container">
                <div class="sub-title">{{ 'LIST_COLUMNS.DISTRIBUTION_METHOD' | translate }}</div>
                <select class="bin-name-input distrebution-Methods" formControlName="WorkPlanDistrebutionMethods" id="workPlan_distrebution_methods">
                  @for (method of workPlanDistrebutionMethods; track method) {
                    <option [value]="method['distrebution_method_id']" class="method-option">
                      {{currentLang != 'iw' ? method['distrebution_method_name'] : method['distrebution_method_name_hebrew']}}
                    </option>
                  }
                </select>
              </div>
  
              <div class="bin-name-container">
                <div class="sub-title">{{ 'LIVE_INFO.TRANSMISSION_TIME' | translate }}</div>
                <mat-form-field class="field-form small-width" rtlDiv>
                  <div class="bin-name-input">
                    <input class="cursor-point input-bin-name" [ngxTimepicker]="transmission_time" [format]="24" matInput formControlName="transmission_time">
                  </div>
                  <ngx-material-timepicker [theme]="staticTheme" [confirmBtnTmpl]="confirmBtn" [cancelBtnTmpl]="cancelBtn" #transmission_time></ngx-material-timepicker>
                  <ng-template #cancelBtn>
                    <div class="manage-bins-btn-container" rtlDiv>
                      <a class="manage-bins-btn" rtlDiv>{{ 'MANAGE_BIN.CANCEL' | translate }}</a>
                    </div>
                  </ng-template>
                  <ng-template #confirmBtn>
                    <div class="manage-bins-btn-container" rtlDiv>
                      <a class="manage-bins-btn" rtlDiv>{{ 'SITE_MANAGMENT.OK' | translate }}</a>
                    </div>
                  </ng-template>
                </mat-form-field>
              </div>
  
              <div class="bin-name-container">
                <div class="sub-title">
                  <span> {{ 'MANAGE_SITE.SHIFTS' | translate }} </span>
                  @if (filtersFormArray.controls.length > 0) {
                    <span> ({{filtersFormArray.controls.length}}) </span>
                  }
                </div>
                <div class="shifts-manager" rtlDiv>
                  <div class="shifts-names" rtlDiv>
                    {{getShiftsNames()}}
                  </div>
                  <div class="add-shift" (click)="addFilterToFiltersFormArray()" rtlDiv>
                    <img src="assets/images/inventory/green-plus.svg" alt=""/>
                    {{ 'MANAGE_SITE.ADD_SHIFTS' | translate }}
                  </div>
                </div>
                <form [formGroup]="dynamicForm">
                  <div formArrayName="shifts">
                    @if (filtersFormArray.controls.length > 0) {
                      <div class="shifts-container">
                        <div class="shift-row-title">
                          <div class="medium-width">{{ 'MANAGE_SITE.SHIFT_NAME' | translate }}</div>
                          <div class="small-width">{{ 'MANAGE_SITE.START' | translate }}</div>
                          <div class="small-width">{{ 'MANAGE_SITE.DURATION' | translate }}</div>
                        </div>
                        @for (filter of filtersFormArray.controls; track filter; let i = $index) {
                          <div>
                            <div [formGroupName]="i" class="shift-row">
                              <mat-form-field class="field-form medium-width" rtlDiv>
                                <input class="input-field" type="text" matInput formControlName="name" rtlDiv>
                              </mat-form-field>
                              <mat-form-field class="field-form small-width" rtlDiv>
                                <input class="input-field cursor-point" [ngxTimepicker]="start_time" [format]="24" matInput formControlName="start_time">
                                <ngx-material-timepicker [theme]="staticTheme" [confirmBtnTmpl]="confirmBtn" [cancelBtnTmpl]="cancelBtn" #start_time></ngx-material-timepicker>
                                <ng-template #cancelBtn>
                                  <div class="manage-bins-btn-container" rtlDiv>
                                    <a class="manage-bins-btn" rtlDiv>{{ 'MANAGE_BIN.CANCEL' | translate }}</a>
                                  </div>
                                </ng-template>
                                <ng-template #confirmBtn>
                                  <div class="manage-bins-btn-container" rtlDiv>
                                    <a class="manage-bins-btn" rtlDiv>{{ 'SITE_MANAGMENT.OK' | translate }}</a>
                                  </div>
                                </ng-template>
                              </mat-form-field>
                              <mat-form-field class="field-form small-width" rtlDiv>
                                <input class="input-field" type="text" matInput formControlName="duration" rtlDiv>
                              </mat-form-field>
                              <div class="cursor-point xsmall-width" (click)="removeFilterFromFiltersFormArray(i)">
                                <img src="assets/images/dashboard/closeX.svg" alt=""/>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </form>
              </div>
  
              <div class="bin-name-container">
                <div class="sub-title">{{ 'MANAGE_SITE.SET_FIXED_DAYS_TO_COLLECT' | translate }}</div>
                <select id="customer_chedule_policy" class="bin-name-input distrebution-Methods" formControlName="customerWorkPlanCollectionschedulePolicy">
                  @for (policy of customerWorkPlanCollectionschedulePolicy; track policy) {
                    <option [value]="policy['customer_work_plan_collection_schedule_policy_id']" class="method-option">
                      {{currentLang != 'iw' ? policy['customer_work_plan_collection_schedule_policy_name'] : policy['customer_work_plan_collection_schedule_policy_name_hebrew']}}
                    </option>
                  }
                </select>
              </div>
  
              <div class="map-points">
                <div class="bin-name-container">
                  <div class="sub-title"></div>
                  <mat-tab-group [(selectedIndex)]="selectedTab" (selectedTabChange)="tabChanged($event)">
                    <mat-tab>
                      <ng-template mat-tab-label>
                        @if (selectedTab == 0) {
                          <img src="assets/images/inventory/start-point-active.svg" alt=""/>
                        }
                        @if (selectedTab != 0) {
                          <img src="assets/images/inventory/start-point-tab.svg" alt=""/>
                        }
                        {{ 'MANAGE_SITE.START' | translate }}
                      </ng-template>
                      <div class="tab-content">
                        <div class="search-bar">
                          <div class="search-input-frame">
                            <img class="search-img" src="assets/images/sidemenu/table_search_icon.png" alt="" />
                            <input id="start_address" (onAddressChange)="handleStartAddressChange($event)" ngx-gp-autocomplete #placesRef="ngx-places" (keyup.enter)="applyFilter()" type="text" class="search-input" formControlName="startLonLat"  placeholder="{{'OTHER.SEARCH' | translate}}"/>                            
                          </div>
                          <div class="apply-btn" (click)="applyFilter()" rtlDiv>
                            {{ 'TITLES.APPLY' | translate }}
                          </div>
                        </div>                      
                        <div class="toggle-container">
                          <div class="edit-toggle-txt">{{ 'TITLES.EDIT' | translate }}</div>
                          @if (showDefaultIconsInStartPointMap) {
                            <img class="cursor-point" (click)="toggleDefaultIconsInStartPointMap()" src="assets/images/workplans-page/exception toggle on.svg" alt="" />
                          }
                          @if (!showDefaultIconsInStartPointMap) {
                            <img class="cursor-point" (click)="toggleDefaultIconsInStartPointMap()" src="assets/images/workplans-page/exeptions toggle off.svg" alt="" />
                          }
                        </div>
                        <google-map
                          [options]="mapOptionsPc"
                          (mapInitialized)="loadAPIWrapperForStartPoint($event)"
                          class="map-manage-modal">
                          @for (bin of markersArrayStartPoint; track bin; let i = $index) {
                            <map-marker
                              [position]="{lat: bin.lat, lng: bin.lng}"
                              [visible]="bin.visible"
                              [options]="{ icon: { url: bin.icon } , draggable : bin.draggable }"
                            (mapDragend)="markerStartPointDragEnd($event)"></map-marker>
                          }
                        </google-map>
                      </div>
                    </mat-tab>
  
                    <mat-tab>
                      <ng-template mat-tab-label>
                        @if (selectedTab == 1) {
                          <img src="assets/images/inventory/finish-point-active.svg" alt=""/>
                        }
                        @if (selectedTab != 1) {
                          <img src="assets/images/inventory/finish-point-tab.svg" alt=""/>
                        }
                        {{ 'MANAGE_SITE.FINISH' | translate }}
                      </ng-template>
                      <div class="tab-content">
                        <div class="search-bar">
                          <div class="search-input-frame">
                            <img class="search-img" src="assets/images/sidemenu/table_search_icon.png" alt="" />
                            <input id="finish_address" (onAddressChange)="handleFinishAddressChange($event)" ngx-gp-autocomplete #placesRef="ngx-places" (keyup.enter)="applyFilter()" type="text" class="search-input" formControlName="finishLonLat"  placeholder="{{'OTHER.SEARCH' | translate}}"/>                            
                          </div>
                          <div class="apply-btn" (click)="applyFilter()" rtlDiv>
                            {{ 'TITLES.APPLY' | translate }}
                          </div>
                        </div>                      
                        <div class="toggle-container">
                          <div class="edit-toggle-txt">{{ 'TITLES.EDIT' | translate }}</div>
                          @if (showDefaultIconsInFinishPointMap) {
                            <img class="cursor-point" (click)="toggleDefaultIconsInFinishPointMap()" src="assets/images/workplans-page/exception toggle on.svg" alt="" />
                          }
                          @if (!showDefaultIconsInFinishPointMap) {
                            <img class="cursor-point" (click)="toggleDefaultIconsInFinishPointMap()" src="assets/images/workplans-page/exeptions toggle off.svg" alt="" />
                          }
                        </div>
                        <google-map
                          [options]="mapOptionsPc"
                          (mapInitialized)="loadAPIWrapperForFinishPoint($event)"
                          class="map-manage-modal">
                          @for (bin of markersArrayFinishPoint; track bin; let i = $index) {
                            <map-marker
                              [position]="{lat: bin.lat, lng: bin.lng}"
                              [visible]="bin.visible"
                              [options]="{ icon: { url: bin.icon } , draggable : bin.draggable }"
                            (mapDragend)="markerFinishPointDragEnd($event)"></map-marker>
                          }
                        </google-map>
                      </div>
                    </mat-tab>
  
                    <mat-tab>
                      <ng-template mat-tab-label>
                        @if (selectedTab == 2) {
                          <img src="assets/images/inventory/unloading-point-active.svg" alt=""/>
                        }
                        @if (selectedTab != 2) {
                          <img src="assets/images/inventory/unloading-point-tab.svg" alt=""/>
                        }
                        {{ 'MANAGE_SITE.UNLOADING' | translate }}
                      </ng-template>
                      <div class="tab-content">
                        <div class="search-bar">
                          <div class="search-input-frame">
                            <img class="search-img" src="assets/images/sidemenu/table_search_icon.png" alt="" />
                            <input id="dump_address" (onAddressChange)="handleDumpAddressChange($event)" ngx-gp-autocomplete #placesRef="ngx-places" (keyup.enter)="applyFilter()" type="text" class="search-input" formControlName="dumpLonLat"  placeholder="{{'OTHER.SEARCH' | translate}}"/>                            
                          </div>
                          <div class="apply-btn" (click)="applyFilter()" rtlDiv>
                            {{ 'TITLES.APPLY' | translate }}
                          </div>
                        </div>                      
                        <div class="toggle-container">
                          <div class="edit-toggle-txt">{{ 'TITLES.EDIT' | translate }}</div>
                          @if (showDefaultIconsInUnloadingPointMap) {
                            <img class="cursor-point" (click)="toggleDefaultIconsInUnloadingPointMap()" src="assets/images/workplans-page/exception toggle on.svg" alt="" />
                          }
                          @if (!showDefaultIconsInUnloadingPointMap) {
                            <img class="cursor-point" (click)="toggleDefaultIconsInUnloadingPointMap()" src="assets/images/workplans-page/exeptions toggle off.svg" alt="" />
                          }
                        </div>
                        <google-map
                          [options]="mapOptionsPc"
                          (mapInitialized)="loadAPIWrapperForUnloadingPoint($event)"
                          class="map-manage-modal">
                          @for (bin of markersArrayDumpPoint; track bin; let i = $index) {
                            <map-marker
                              [position]="{lat: bin.lat, lng: bin.lng}"
                              [visible]="bin.visible"
                              [options]="{ icon: { url: bin.icon } , draggable : bin.draggable }"
                            (mapDragend)="markerDumpPointDragEnd($event)"></map-marker>
                          }
                        </google-map>
                      </div>
                    </mat-tab>
                  </mat-tab-group>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
  
        <mat-accordion>
          <mat-expansion-panel [expanded]="true" (opened)="advancedSettingsOpenState = true" (closed)="advancedSettingsOpenState = false" class="panel-accordion">
            <mat-expansion-panel-header class="panel-accordion-header">
              <mat-panel-title class="panel-accordion-title">
                {{ 'SITE_MANAGMENT.ADVANCED_SET' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div [ngClass]="{'hide-panel' : !advancedSettingsOpenState}">
              <div class="bin-name-container">
                <div class="sub-title">{{ 'MANAGE_SITE.SET_MAX_VOLUME' | translate }}</div>
                <select id="site_capacity" class="bin-name-input distrebution-Methods" formControlName="useSiteMaxAllowedCapacity" (change)="setVolumeType()">
                  <option [value]="0" class="method-option">
                    {{ 'MANAGE_SITE.MAX_VOLUME_BIN' | translate }}
                  </option>
                  <option [value]="1" class="method-option">
                    {{ 'MANAGE_SITE.MAX_VOLUME_SITE' | translate }}
                  </option>
                </select>
              </div>
  
              @if (showVolume) {
                <div class="bin-name-container">
                  <div class="sub-title">{{ 'MANAGE_SITE.MAXIMUM_VOLUME' | translate }}</div>
                  <div>
                    <input id="site_volume" type="text" class="time-input" formControlName="capacity" name="capacity"/>
                  </div>
                </div>
              }
  
              <div class="bin-name-container">
                <div class="sub-title"></div>
                <div class="dflex">
                  <label class="container-extra" rtlDiv>
                    {{ 'MANAGE_SITE.VOLUME_BASED_SORT' | translate }}
                    <input id="volume_based" formControlName="isVolumeBasedSort" [checked]="isVolumeBased" type="checkbox" (change)="toggleEditableVolume(!isVolumeBased)" rtlDiv>
                    <span class="checkmark" rtlDiv></span>
                  </label>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
  
        <mat-accordion>
          <mat-expansion-panel [expanded]="true" (opened)="alertsOpenState = true" (closed)="alertsOpenState = false" class="panel-accordion">
            <mat-expansion-panel-header class="panel-accordion-header">
              <mat-panel-title class="panel-accordion-title">
                {{ 'MANAGE_SITE.ALERTS_SETTINGS' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div [ngClass]="{'hide-panel' : !alertsOpenState}">
              <div class="bin-name-container">
                <div class="sub-title">{{ 'MANAGE_SITE.UNCOLLECTED_BIN_ALERT_NUM_OF_DAYS' | translate }}</div>
                <div>
                  <input type="text" class="time-input" formControlName="daysGapForNoCollections" name="daysGapForNoCollections"/>
                </div>
              </div>
  
              <div class="bin-name-container">
                <div class="sub-title">{{ 'MANAGE_SITE.AUTOMATIC_WORKPLAN' | translate }}</div>
                <div class="dflex">
                  <div class="row-space" rtlDiv>
                    <div class="sub-subTitle">{{ 'MANAGE_SITE.MIN_AVG_VOLUME_REQUIRED' | translate }}</div>
                    <input type="text" class="time-input" formControlName="minAverageVolume" name="minAverageVolume"/>
                  </div>
                  <div>
                    <div class="sub-subTitle">{{ 'MANAGE_SITE.MAX_NUM_OF_DAYS_FORECAST' | translate }}</div>
                    <input type="text" class="time-input" formControlName="maxNumberDaysForecast" name="maxNumberDaysForecast"/>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </form>
    </div>
    <div class='main-btns-wrapper'>
      <div class='btns-container' rtlDiv>
        <div class='cancel-btn' (click)="closeModal()">{{ 'MANAGE_BIN.CANCEL' | translate }}</div>
        <button [ngClass]="{'apply-btn' : ElForm.valid && !submitClicked,'not-apply-btn' : !ElForm.valid || submitClicked}" [disabled]="!ElForm.valid && !submitClicked" (click)='saveChanges()'>{{ 'MANAGE_BIN.SAVE_CHANGES' | translate }}</button>
      </div>
    </div>
  </div>